import React from "react";
import {
  Nav,
  NavLink,
  NavbarContainer,
  NavLogo,
  NavItems,
  GitHubButton,
  ButtonContainer,
  MobileIcon,
  MobileMenu,
  MobileLink,
  Img2,
} from "./NavbarStyledComponent";
import logo from "../../images/logo.png";
import { FaBars } from "react-icons/fa";
import { Bio } from "../../data/constants";
import { useTheme } from "styled-components";
import { useLanguage } from "../../utils/LanguageContext";
import styled from "styled-components";

const ToggleGroup = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-right: 16px;

  @media screen and (max-width: 768px) {
    margin-right: 0;
    margin-top: 8px;
  }
`;

const ToggleBtn = styled.button`
  background: transparent;
  border: 1.5px solid ${({ theme }) => theme.primary};
  color: ${({ theme }) => theme.primary};
  border-radius: 12px;
  padding: 6px 12px;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;

  &:hover {
    background: ${({ theme }) => theme.primary};
    color: ${({ theme }) => theme.white};
  }

  @media screen and (max-width: 768px) {
    padding: 8px 14px;
    font-size: 14px;
  }
`;

const MobileLangBtn = styled.button`
  display: none;
  background: transparent;
  border: 1.5px solid ${({ theme }) => theme.primary};
  color: ${({ theme }) => theme.primary};
  border-radius: 10px;
  padding: 5px 10px;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;

  &:hover {
    background: ${({ theme }) => theme.primary};
    color: ${({ theme }) => theme.white};
  }

  @media screen and (max-width: 768px) {
    display: block;
    position: absolute;
    right: 50px;
    top: 0;
    transform: translate(-100%, 60%);
  }
`;

const Navbar = ({ toggleTheme, darkMode }) => {
  const [isOpen, setIsOpen] = React.useState(false);
  const theme = useTheme();
  const { t, toggleLanguage, language } = useLanguage();

  return (
    <Nav>
      <a
        href="#main-content"
        style={{
          position: "absolute",
          left: "-9999px",
          top: "auto",
          width: "1px",
          height: "1px",
          overflow: "hidden",
        }}
      >
        Skip to main content
      </a>
      <NavbarContainer>
        <NavLogo to="/">
          <span
            style={{
              display: "flex",
              alignItems: "center",
              color: "white",
              cursor: "pointer",
            }}
          >
            <Img2 src={logo} alt="Messi II Innocent R. - Portfolio Logo" />
          </span>
        </NavLogo>
        <MobileLangBtn
          onClick={toggleLanguage}
          aria-label={`Switch to ${language === "en" ? "French" : "English"}`}
        >
          {language === "en" ? "FR" : "EN"}
        </MobileLangBtn>
        <MobileIcon>
          <FaBars
            aria-label="Open navigation menu"
            role="button"
            tabIndex={0}
            onClick={() => setIsOpen(!isOpen)}
            onKeyDown={(e) => {
              if (e.key === "Enter" || e.key === " ") setIsOpen(!isOpen);
            }}
          />
        </MobileIcon>
        <NavItems role="navigation" aria-label="Main navigation">
          <NavLink href="#about">{t.about}</NavLink>
          <NavLink href="#skills">{t.skills}</NavLink>
          <NavLink href="#experience">{t.experience}</NavLink>
          <NavLink href="#projects">{t.projects}</NavLink>
          <NavLink href="#education">{t.education}</NavLink>
        </NavItems>
        <ButtonContainer>
          <ToggleGroup>
            <ToggleBtn
              onClick={toggleTheme}
              aria-label={darkMode ? "Switch to light mode" : "Switch to dark mode"}
              title={darkMode ? "Light Mode" : "Dark Mode"}
            >
              {darkMode ? "☀️" : "🌙"}
            </ToggleBtn>
            <ToggleBtn
              onClick={toggleLanguage}
              aria-label={`Switch to ${language === "en" ? "French" : "English"}`}
              title={language === "en" ? "Français" : "English"}
            >
              {language === "en" ? "FR" : "EN"}
            </ToggleBtn>
          </ToggleGroup>
          <GitHubButton href={Bio.github} target="_blank" rel="noopener noreferrer" aria-label="Visit GitHub Profile">
            {t.githubProfile}
          </GitHubButton>
        </ButtonContainer>
        {isOpen && (
          <MobileMenu isOpen={isOpen} role="navigation" aria-label="Mobile navigation">
            <MobileLink href="#about" onClick={() => setIsOpen(false)}>
              {t.about}
            </MobileLink>
            <MobileLink href="#skills" onClick={() => setIsOpen(false)}>
              {t.skills}
            </MobileLink>
            <MobileLink href="#experience" onClick={() => setIsOpen(false)}>
              {t.experience}
            </MobileLink>
            <MobileLink href="#projects" onClick={() => setIsOpen(false)}>
              {t.projects}
            </MobileLink>
            <MobileLink href="#education" onClick={() => setIsOpen(false)}>
              {t.education}
            </MobileLink>
            <ToggleGroup>
              <ToggleBtn onClick={toggleTheme}>
                {darkMode ? "☀️ Light" : "🌙 Dark"}
              </ToggleBtn>
              <ToggleBtn onClick={toggleLanguage}>
                {language === "en" ? "🇫🇷 FR" : "🇬🇧 EN"}
              </ToggleBtn>
            </ToggleGroup>
            <GitHubButton
              style={{
                padding: "10px 16px",
                background: `${theme.primary}`,
                color: "white",
                width: "max-content",
              }}
              href={Bio.github}
              target="_blank"
              rel="noopener noreferrer"
            >
              {t.githubProfile}
            </GitHubButton>
          </MobileMenu>
        )}
      </NavbarContainer>
    </Nav>
  );
};

export default Navbar;
